import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Course } from '@/module/Author/Course';
import { CourseValidationAction } from '@/module/Author/Course/Validation/CourseValidationAction';
import { CourseCard } from '@/module/Author/Course/components/Card/CourseCard';

interface CollapsableCourseProps {
  title: string;
  courses: Course[];
}

export function CollapsableCourse({ title, courses }: CollapsableCourseProps) {
  return (
    <CollapsableGroup
      title={title}
      items={courses}
      renderValidation={course => (
        <CourseValidationAction
          variant="compact"
          courseId={course.id}
        />
      )}
      renderItem={course => (
        <CourseCard
          course={course}
          onClick={() => window.open(`/author/course/${course.id}`)}
        />
      )}
    />
  );
}
